module.exports = __webpack_public_path__ + "static/media/ico-social01.2e09bec8.svg";